// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Scroll from "react-scroll"; // Imports all Mixins
import { Grid, Row } from "react-bootstrap";
import { makeSelectData, makeSelectTransfers } from "../QuotePage/selectors";
import UpdateUser from "./PersonalDetails/";
import { changeBasketCurrency, updateNotification } from "../../actions/basket";
import TagManager from "react-gtm-module";

class CompleteBooking extends Component {
  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });

    /*
    maybe here we put the GTM code to update the JavaScript dataLayer with purchase information
    as defined: https://docs.google.com/document/d/153-JUWbyKjy4wTgCzOjOM6ZvJCNi9M6bVJ6Va5c5rzM/edit
    */

    const totalPaid = this.props.basketData.totalPaid
      ? this.props.basketData.totalPaid
      : 0;

    if (this.props.transfers && totalPaid > 0) {
      /* Tag Manager */
      const tagManagerArgs = {
        gtmId: "GTM-PC8TZH",
        dataLayer: {
          event: "transaction",
          email: this.props.transfers[0].email,
          firstname: this.props.transfers[0].forename, //FirstName field value from Transfer One Lead Passenger details
          surname: this.props.transfers[0].surname, //Surname field value from Transfer One Lead Passenger details
          journeyDate: this.props.transfers[0].date, // journey date from Transfer One
          numberOfChildren: this.props.transfers[0].children.length.toString(), // Children field  value from Transfer One booking details
          numberOfAdults: this.props.transfers[0].adults, // Adults field value from Transfer One booking details
          transactionId: this.props.basketData.bookingId,
          transactionTotal: (totalPaid / 100).toFixed(2),
          currencyCode: this.props.basketData.currency[0],
          transactionProducts: []
        }
      };

      tagManagerArgs.dataLayer.transactionProducts[0] = {
        sku: this.props.transfers[0].id, //If you assign an ID to Type of Transfer, you can put it there
        name:
          this.props.transfers[0].fromDestination.name +
          " to " +
          this.props.transfers[0].toDestination.name,
        category: this.props.transfers[0].transferType.code, //Type of Transfer
        price: (this.props.transfers[0].transferType.totalCost / 100).toFixed(
          2
        ),
        quantity: 1
      };

      if (this.props.transfers[1]) {
        tagManagerArgs.dataLayer.transactionProducts[1] = {
          sku: this.props.transfers[1].id, //If you assign an ID to Type of Transfer, you can put it there
          name:
            this.props.transfers[1].fromDestination.name +
            " to " +
            this.props.transfers[1].toDestination.name,
          category: this.props.transfers[1].transferType.code, //Type of Transfer
          price: (this.props.transfers[0].transferType.totalCost / 100).toFixed(
            2
          ),
          quantity: 1
        };
      }

      TagManager.initialize(tagManagerArgs);
      /* Affiliate Futures */
      
      if (this.props.transfers && totalPaid > 0 &&  process.env.NODE_ENV === "production") {
        AFProcessSaleV5(
          "6953",
          (totalPaid / 100).toFixed(2),
          this.props.basketData.bookingId,
          "",
          "",
          "",
          "",
          this.props.basketData.currency[0]
        );
      }
    }
  }

  render() {
    if (!this.props.transfers) {
      return (
        <div className="text-center">
          <h1 style={{ color: "red" }}>Server Error</h1>
        </div>
      );
    }
    const inboundData = this.props.transfers[1]
      ? this.props.transfers[1]
      : null;

    return (
      <Grid className="complete" fluid>
        <Row className="personal-details">
          <UpdateUser
            inboundData={inboundData}
            outboundData={this.props.transfers[0]}
            changeBasketCurrency={this.props.changeBasketCurrency}
            id={this.props.basketData.id}
            resultText={this.props.basketData.resultText}
          />
        </Row>
      </Grid>
    );
  }
}

const getCookie = name => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const  AFProcessSaleV5= function(
  merchantID,
  orderValue,
  orderRef,
  payoutCodes,
  offlineCode,
  voucherCodes,
  productList,
  sourceCurrency
){
  let iframe = document.createElement("iframe");
  let secure = document.location.toString().indexOf("https") === 0;
  let affc = getCookie("Affc");

  let RN = Math.random().toString();
  let RNS = RN.substring(2, 11);

  voucherCodes = voucherCodes || "";
  productList = productList || "";
  sourceCurrency = sourceCurrency || "";

  iframe.border = "0";
  iframe.width = "1";
  iframe.height = "1";

  if (secure) {
    iframe.src = `https://scripts.affiliatefuture.com/AFSaleV5.aspx?orderID=${orderRef}&orderValue=${orderValue}&merchant=${merchantID}&payoutCodes=${payoutCodes}&offlineCode=${offlineCode}&voucher=${voucherCodes}&products=${productList}&curr=${sourceCurrency}&affc=${affc}&r=${RNS}`;
  } else {
    iframe.src = `http://scripts.affiliatefuture.com/AFSaleV5.aspx?orderID=${orderRef}&orderValue=${orderValue}&merchant=${merchantID}&payoutCodes=${payoutCodes}&offlineCode=${offlineCode}&voucher=${voucherCodes}&products=${productList}&curr=${sourceCurrency}&affc=${affc}&r=${RNS}`;
  }

  document.body.appendChild(iframe);
};

const mapStateToProps = createStructuredSelector({
  basketData: makeSelectData(),
  transfers: makeSelectTransfers()
});

export default connect(mapStateToProps, {
  changeBasketCurrency,
  updateNotification
})(CompleteBooking);



// WEBPACK FOOTER //
// ./src/containers/CompleteBooking/index.js